module.exports = __webpack_public_path__ + "static/media/highlight-location.52cd68dc.svg";